import { Injectable, inject } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from "@angular/material/snack-bar";
import { SnackbarComponent } from "./snackbar.component";

export type SnackbarType = "success" | "error";

@Injectable({ providedIn: "root" })
export class SnackbarService {
  private snackbar = inject(MatSnackBar);

  snackbarRef: MatSnackBarRef<SnackbarComponent> | undefined;

  openSnackBar(
    message: string,
    snackbarType: SnackbarType,
    action?: string,
    options: MatSnackBarConfig = {}
  ): MatSnackBarRef<SnackbarComponent> {
    this.snackbarRef = this.snackbar.openFromComponent(
      SnackbarComponent,
      Object.assign(
        {
          duration: 5000,
          verticalPosition: "top",
          panelClass: [
            this.getPanelClass(snackbarType),
            "mat-typography",
            "onsip-snackbar",
            "onsip-snackbar-top"
          ],
          data: { message, snackbarType, action }
        },
        options
      )
    );
    this.snackbarRef.instance.snackBarRef = this.snackbarRef;
    return this.snackbarRef;
  }

  dismiss(): void {
    this.snackbarRef && this.snackbarRef.dismiss();
  }

  private getPanelClass(type: SnackbarType | undefined): string {
    return type ? `onsip-snackbar-${type}-background` : "";
  }
}
